import { AttachFile } from "@mui/icons-material";
import React from "react";
import { PluginComponent } from "react-markdown-editor-lite";

export interface AttachmentPluginConfig {
	attachmentCount: number;
	onAttachmentClick: () => void;
}

export default class AttachmentPlugin extends PluginComponent {
	static pluginName = "attachment";
	static align = "left";
	static defaultConfig = {
		start: 0,
		end: 0,
	};

	render() {
		const { attachmentCount, onAttachmentClick } = this.props
			.config as AttachmentPluginConfig;

		return (
			<span
				className="button button-type-attachment"
				title={`Attachments (${attachmentCount})`}
				onClick={onAttachmentClick}
				style={{
					display: "inline-flex",
					alignItems: "center",
					padding: "4px 8px",
					cursor: "pointer",
					borderRadius: "4px",
					backgroundColor: attachmentCount > 0 ? "#e3f2fd" : "transparent",
					border:
						attachmentCount > 0 ? "1px solid #2196f3" : "1px solid transparent",
					color: attachmentCount > 0 ? "#1976d2" : "#666",
					fontSize: "0.75rem",
					fontWeight: attachmentCount > 0 ? 600 : 400,
					transition: "all 0.2s ease-in-out",
				}}
				onMouseEnter={(e) => {
					e.currentTarget.style.backgroundColor = "#e3f2fd";
					e.currentTarget.style.borderColor = "#2196f3";
				}}
				onMouseLeave={(e) => {
					if (attachmentCount === 0) {
						e.currentTarget.style.backgroundColor = "transparent";
						e.currentTarget.style.borderColor = "transparent";
					}
				}}
			>
				<AttachFile
					style={{
						fontSize: 16,
						marginRight: 4,
						color: attachmentCount > 0 ? "#1976d2" : "#666",
					}}
				/>
				Attachments ({attachmentCount})
			</span>
		);
	}
}
